// BESKAR tasarım katmanı — küçük etkileşimler (3 Kasım 2026)
// Numara seçilmeden satın alma alanına dokunulursa numara seçimini göster.
document.addEventListener('click', (event) => {
  const area = event.target instanceof Element && event.target.closest('product-form-component, .buy-buttons-block, sticky-add-to-cart');
  if (!area) return;
  const scope = area.closest('[data-bs-size-ready="false"]');
  const sizes = scope?.querySelector('[data-bs-size-option]');
  if (!sizes) return;
  sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
  sizes.classList.remove('bs-pulse');
  void sizes.offsetWidth;
  sizes.classList.add('bs-pulse');
  setTimeout(() => sizes.classList.remove('bs-pulse'), 1200);
});
